
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-studies/curipod-case-study-innovations-academy",
      function () {
        return require("private-next-pages/case-studies/curipod-case-study-innovations-academy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-studies/curipod-case-study-innovations-academy"])
      });
    }
  